import React from 'react';
import Card from '@/components/atoms/Card';
import Button from '@/components/atoms/Button';
import './CalendarControls.scss';

interface CalendarControlsProps {
  monthLabel: string;
  onPrev: () => void;
  onNext: () => void;
  prevLabel: string;
  nextLabel: string;
}

const CalendarControls: React.FC<CalendarControlsProps> = ({
  monthLabel,
  onPrev,
  onNext,
  prevLabel,
  nextLabel
}) => {
  return (
    <Card variant="elevated" padding="md" className="events-calendar-page__controls">
      <Button
        variant="ghost"
        size="sm"
        onClick={onPrev}
      >
        {prevLabel}
      </Button>
      <span className="events-calendar-page__month-label">{monthLabel}</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={onNext}
      >
        {nextLabel}
      </Button>
    </Card>
  );
};

export default CalendarControls;
